var generateStyle = function generateStyle(componentTheme) {
  return {
    dropzone: {
      backgroundColor: componentTheme.dropzoneBackgroundColor,
      border: "".concat(componentTheme.dropzoneBorderWidth, " dashed ").concat(componentTheme.dropzoneBorderColor),
      cursor: 'pointer',
      padding: componentTheme.dropzonePadding
    }
  };
};
export default generateStyle;